// Store vueX
import { Commit, Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '../types';

import AuthService from '@/services/auth';
import { UtilisateurExterne } from '@/services/api/types';
import { getUtilisateurExterneFromApi } from '@/services/api/api';

const UPDATE_LOGGEDIN = 'UPDATE_LOGGEDIN';
const UPDATE_USER_INFORMATION = 'UPDATE_USER_INFORMATION';
const CLEAR_AUTH_STORE = 'CLEAR_AUTH_STORE';

export interface UtilisateurExterneState {
  loggedIn: boolean;
  info: UtilisateurExterne | null;
}

export const state: UtilisateurExterneState = {
  loggedIn: false,
  info: null
};

// Les actions permettent l'exécution de code asynchrone
export const actions: ActionTree<UtilisateurExterneState, RootState> = {
  // Action pour vérifier l'authentification
  async storeAuthentication({ commit }: { commit: Commit }) {
    const isLoggedIn = await AuthService.isLoggedIn();
    commit(UPDATE_LOGGEDIN, isLoggedIn); // Met à jour le state.loggedIn
  },
  // Action pour stocker les informations de l'utilisateur
  async storeUserInformation({ commit }: { commit: Commit }) {
    const response = await getUtilisateurExterneFromApi();
    const userInfo: UtilisateurExterne | null = response.data;

    // Gestion des profils
    const updatedUserInfo = AuthService.gereProfils(userInfo);

    commit(UPDATE_USER_INFORMATION, updatedUserInfo); // Mutation pour stocker les informations dans le store
  },
  async logout({ commit }: { commit: Commit }) {
    AuthService.removeToken();
    commit(CLEAR_AUTH_STORE);
  }
};

export const mutations: MutationTree<UtilisateurExterneState> = {
  UPDATE_LOGGEDIN(state: UtilisateurExterneState, value: boolean) {
    state.loggedIn = value;
  },
  UPDATE_USER_INFORMATION(state: UtilisateurExterneState, info: UtilisateurExterne | null) {
    state.info = info;
  },
  CLEAR_AUTH_STORE(state: UtilisateurExterneState) {
    state.loggedIn = false;
    state.info = null;
  }
};

export const getters: GetterTree<UtilisateurExterneState, RootState> = {
  isLoggedIn: (state: UtilisateurExterneState) => state.loggedIn,
  utilisateurExterneInfo: (state) => state.info
};

// Définition module
export const authentication: Module<UtilisateurExterneState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
